export default __webpack_public_path__ + "static/media/emptyFavoriteIcon.60d40373.svg";